exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".clients-logs-screen .arrow-button {\n  left: 143px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/containers/ClientsLogsScreen/ClientsLogsScreen.scss
// module id = 2024
// module chunks = 0